module.exports = __webpack_public_path__ + "img/icon-loader-basa2.840a78d7.svg";